/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-empty-pattern */
/* eslint-disable  @typescript-eslint/no-unused-vars */

import React, { useEffect, useState } from "react";
import { ConceptoVerificacion } from "src/utils/aspirantes/verificaciones";
import { Alert, Box, Button } from "@mui/material";
import { Form, Formik } from "formik";
import RenderizadorCampo from "./RenderizadorCampo";

export interface campo {
  clave: string;
  campo: string;
  comentario?: string;
  valor: any
}

export interface EditorCamposProps {
  campos: campo[];
  aspiranteId: string;
  submit: (values: any) => void;
}

const EditorDatos = ({ campos, submit, aspiranteId }: EditorCamposProps) => {
    const nuevosValoress: any = {};
        campos.forEach((campo) => {
            if (campo) {
                nuevosValoress[campo.campo] = campo.valor ?? '';
            }
        });
    const [valoresForm, setValoresForm] = useState({
        tipoIdentificacion: 'PASAPORTE',
        perfilId: 'MENTOR',
        sexo: '',
        ...nuevosValoress
    });
    const onSubmit = (values: any) => {
      submit(values);
    }

    useEffect(() => {
        const nuevosValores: any = {};
        campos.forEach((campo) => {
            if (campo) {
                nuevosValores[campo.campo] = campo.valor;
            }
        });
        setValoresForm(nuevosValores);
      }, [campos]);
  return (
    <Box>
      <Formik
        enableReinitialize
        initialValues={{...valoresForm}}
        // validationSchema={esquemaDeValidacion}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue, handleChange }) => {
          return (
            <Form
              autoComplete="off"
              id="form-editor"
              style={{ width: "100%" }}
            >
              {campos.map((campo) => {
                if (campo) {
                  return (<>
                    {campo.comentario && <Alert severity="warning" sx={{mt:2}}> {campo.comentario}</Alert>}
                    <RenderizadorCampo
                      campo={campo.clave as ConceptoVerificacion}
                      values={values}
                      setFieldValue={setFieldValue}
                      aspiranteId={aspiranteId}
                    />
                    <br />
                  </>
                  );
                }
                return null;
              })}
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default EditorDatos;
